export default function PHP_SimpleXMLGet() {
  return (
    <div>
      <h1>PHP_SimpleXMLGet</h1>
    </div>
  );
}
